module.exports = __webpack_public_path__ + "media/images/icons/twotone/thunderbolt-75ab18dd39ea850b6f72b8e641bf0a2f.svg";